<template>
  <div
    class="customer-select"
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    title="Customers list"
    data-ai-agent-type="multi-select"
    data-ai-agent-id="customer-multi-select"
    data-ai-agent-label="Customer"
  >
    <select
      ref="ms"
      class="form-control"
      style="width: 100%;"
      data-ai-agent-type="multi-select"
      data-ai-agent-id="customer-multi-select-native"
      data-ai-agent-label="Customer Native Select"
    >
      <option value="0">
        All customers
      </option>
      <option
        v-for="c in customers"
        :key="c.id"
        :value="c.id"
      >
        {{ c.name }}
      </option>
    </select>
  </div>
</template>
  
  <script>
  import { Tooltip } from "bootstrap";

  export default {
    name: "CustomerMultiSelect",
    props: {
      customers: {
        type: Array,
        default: () => [],
      },
      companySelectorId: {
        type: String,
        default: "company_selector",
      },
    },
    data() {
      return {
        msInstance: null,
        currentCompanyName: "",
        initialized: false,
      };
    },
    watch: {
      customers: {
        handler(newVal) {
          if (newVal.length) this.initMultipleSelect();
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {
      this.getCurrentCompanyName();
      this.initMultipleSelect();
      new Tooltip(this.$el);

      window.aiSelectCustomerByName = this.selectCustomerByName;
    },
    beforeDestroy() {
      if (window.aiSelectCustomerByName === this.selectCustomerByName) {
        delete window.aiSelectCustomerByName;
      }
    },
    methods: {
      initMultipleSelect() {
        if (this.msInstance) {
          $(this.$refs.ms).multipleSelect("destroy");
        }

        this.$nextTick(() => {
          this.msInstance = $(this.$refs.ms).multipleSelect({
            single: true,
            filter: true,
            filterPlaceholder: "Search...",
            placeholder: "All customers",
            selectAll: false,
            showClear: false,
            noMatchesText: "No customers found",
            onClick: (view) => {
              this.emitSelectedCustomerByValue(view.value);
            },
          });

          this.initialized = true;
          this.preselectIfMatch();
        });
      },
      emitSelectedCustomerByValue(value) {
        const selected =
          String(value) === "0"
            ? { id: 0, name: "All customers" }
            : this.customers.find((c) => String(c.id) === String(value));

        this.$emit("select", selected);
      },
      selectCustomerByName(customerName) {
        const match = this.customers.find(
          (c) => c.name.trim().toLowerCase() === customerName.trim().toLowerCase()
        );

        if (!match) return false;

        $(this.$refs.ms).multipleSelect("setSelects", [String(match.id)]);
        this.emitSelectedCustomerByValue(String(match.id));
        return true;
      },
      selectAllCustomers() {
        $(this.$refs.ms).multipleSelect("setSelects", ["0"]);
        this.emitSelectedCustomerByValue("0");
        return true;
      },
      getCurrentCompanyName() {
        const sel = document.getElementById(this.companySelectorId);
        if (sel && sel.selectedIndex >= 0) {
          this.currentCompanyName = sel.options[sel.selectedIndex].text.trim();
        }
      },
      async preselectIfMatch() {
        if (!this.initialized) return;

        if (!this.currentCompanyName) {
          const { data } = await axios.get('/dashboard/user');
          this.currentCompanyName = data?.company?.name;
        }

        const match = this.customers.find(
          (c) =>
            c.name.trim().toLowerCase() ===
            this.currentCompanyName.trim().toLowerCase()
        );

        if (match) {
          $(this.$refs.ms).multipleSelect("setSelects", [String(match.id)]);
          this.$emit("select", match);
        } else {
          $(this.$refs.ms).multipleSelect("setSelects", ["0"]);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .customer-select {
    max-width: 400px;
    min-width: 285px;
  }
  
  .ms-choice {
    background-color: #009879 !important;
    color: white !important;
    border-radius: 6px !important;
  }
  
  .ms-search input {
    border: 1px solid #ccc;
    padding: 4px 6px;
    border-radius: 4px;
  }
  
  .ms-drop ul > li {
    padding: 4px 6px;
    font-size: 14px;
  }
  
  .ms-drop ul > li:hover {
    background-color: #e8f5e9;
  }
  </style>
